var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'Product')?_c('index-page'):_c('router-view',{key:_vm.$route.path + Math.random()})
}
var staticRenderFns = []

export { render, staticRenderFns }